module.exports = __webpack_public_path__ + "img/South-Africa.cadf68e5.png";